import { SyntheticEvent } from 'react';
import { SizeValue } from '@ag1/ui';
import type { UnifiedButton as UnifiedButtonType } from 'types/studio/studio';
import { UnifiedButton } from '../UnifiedButton';

type Props = {
  onClick?: (event: SyntheticEvent) => void;
  sectionType: string;
  className?: string;
  dataTestId?: string;
  size?: SizeValue | ResponsiveSizeValue<SizeValue>;
  theme?: 'old' | 'new';
  disableButtonEvents?: boolean;
  isLoading?: boolean;
  ingredientModalDetail: UnifiedButtonType;
};

const IngredientModalSection = ({
  ingredientModalDetail,
  sectionType,
  dataTestId,
  className,
  size,
  onClick,
  theme,
  disableButtonEvents,
  isLoading
}: Props) => {
  return (
    <UnifiedButton
      unifiedButton={ingredientModalDetail}
      sectionType={sectionType}
      dataTestId={dataTestId}
      className={className}
      size={size}
      onClick={onClick}
      theme={theme}
      disableButtonEvents={disableButtonEvents}
      isLoading={isLoading}
    />
  );
};

export default IngredientModalSection;
